import * as types from "./consts";

export const getProductListRequest = (payload?: string) => ({
    type: types.GET_PRODUCT_LIST_REQUEST,
    payload,
});
